import type { AccessoriesV2, AccessoryV2 } from "@credit-acceptance/step6-bff-client";
import { useTranslation } from "react-i18next";

import { formatCurrency } from "../../../../lib/money";
import type { AuditTableColumn } from "../../../audit/AuditTable";
import SummaryTableModal from "../../components/SummaryTableModal";
import { EMPTY_VALUE, formatOptional } from "./financialFormat";

interface AccessoriesModalProperties {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  accessories: AccessoriesV2;
}

// Read-only breakdown of the accessories in Selling Price, opened from the "Accessories" link
function AccessoriesModal({ open, onOpenChange, accessories }: AccessoriesModalProperties) {
  const { t } = useTranslation();

  const columns: Array<AuditTableColumn<AccessoryV2>> = [
    { key: "name", header: t("financial.modalColumns.name"), render: (item) => item.name || EMPTY_VALUE },
    { key: "type", header: t("financial.modalColumns.type"), render: (item) => item.type || EMPTY_VALUE },
    {
      key: "customerPrice",
      header: t("financial.modalColumns.customerPrice"),
      render: (item) => formatOptional(item.customerPrice, formatCurrency),
    },
    {
      key: "dealerCost",
      header: t("financial.modalColumns.dealerCost"),
      render: (item) => formatOptional(item.dealerCost, formatCurrency),
    },
  ];

  return (
    <SummaryTableModal
      open={open}
      onOpenChange={onOpenChange}
      title={t("financial.accessoriesModal.title")}
      description={t("financial.accessoriesModal.description")}
      caption={t("financial.accessoriesModal.caption")}
      summaryLines={[
        {
          label: t("financial.accessoriesModal.totalPrice"),
          value: formatOptional(accessories.totalPrice, formatCurrency),
        },
        {
          label: t("financial.accessoriesModal.totalCost"),
          value: formatOptional(accessories.totalCost, formatCurrency),
        },
      ]}
      columns={columns}
      rows={accessories.details ?? []}
    />
  );
}

export default AccessoriesModal;
